import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  Table,
  Form,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {
  
  URL,
  localFilePath,
  fotoStyle,
  fotoStyle2
} from "../../redux/actions/constants";
import CgnButton from "../toolbox/CgnButton";
import CgnTextbox from "../toolbox/CgnTextbox";
import CgnMessage from "../toolbox/CgnMessage";
import { confirmAlert } from "react-confirm-alert";
import pdfIcon from "../../images/pdfIcon.png";
import noImg from "../../images/no-img.png";
import ImageUploadMulti from "../toolbox/CgnImageUploadMulti";
import CgnButtonGroup from "../toolbox/CgnButtonGroup";

class CustomerDocumentOtherDetail extends Component {
  state = {
    pageTitle: "Diğer Çeviri İşlemleri Detay (ÜTS Dışı)",
    pageTitleDetail: "Diğer Çeviri İşlemleri Detay (ÜTS Dışı)",
    pageAddLink: "musteri-diger-islemler-ekle",
    pageListLink: "musteri-diger-islemler-listele",
    breadcrumb: [{ text: "Diğer Çeviri İşlemleri", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    customerName: "",
    total: "",
    addTotal: "",
    status: "",
    customerDocumentOtherImageDto: [],
    otherTranslationDocumentDto: [],
    offerTotal: "",
    currencyType: "",
    remainingAmount: "",
    customerMail: "",
    guid: "",
    createdBy: "",
    productName: "",
    barcode: "",
    productImage: "",
    tag: "",
    gtipNo: "",
    description: "",
    createdAt: "",
    isLoadingModal: false,
    updatedAt: "",
    updatedBy: "",
    paymentValue: "",
    isOpenModalPayment: false,
    paymentValueEFT: "",
    isOpenModalPaymentEFT: false,
    customerDocumentOtherImageDtoError: "",
    buttons: [
      {
        type: "submit",
        color: "primary",
        text: CgnMessage.saveButton,
        disabled: this.isLoading,
      },
    ]
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/customerDocumentOthers/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            guid: response.data.guid,
            customerName: response.data.customerName,
            customerMail: response.data.customerMail,
            description: response.data.description,
            status: response.data.status,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            isLoading: false,
            offerTotal: response.data.offerTotal,
            currencyType: response.data.currencyType,
            customerGuid: response.data.customerGuid,
            customerDocumentOtherImageDto: response.data.customerDocumentOtherImageDto,
            total: response.data.total,
            remainingAmount: response.data.remainingAmount,
            otherTranslationDocumentDto: response.data.otherTranslationDocumentDto,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  uploadedImage2 = async (event) => {
    let array = this.state.customerDocumentOtherImageDto;
    const files = event.target.files;
    for(var i = 0; i < files.length; i++){
      const file = event.target.files[i];
      if(file.type === "application/pdf"){
        const formData = new FormData();
        formData.append("files", file);
        // 
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        };
        await axios
          .post(URL + "/uploads/add", formData, config)
          .then((response) => {
            array.push({
                image: response.data,
                imageName: file.name
            })
            this.state.name2 += file.name + " ";
          })
          .catch((error) => {
            this.setState({
              alertErrorMessage: error.response.data,
            });
          });
      }
    }
    await this.setState({customerDocumentOtherImageDto: array});
  };

  deleteImage2 = (event) => {
    var index = -1;
    let array = this.state.customerDocumentOtherImageDto;
     this.state.customerDocumentOtherImageDto.forEach((element) => {
      index++;
        if(element.image === event){         
          if (index !== -1) {
            array.splice(index, 1);
            this.setState({customerDocumentOtherImageDto: array});
          }
        }
     });
  };

  uploadedImage3 = async (event) => {
    let array = this.state.otherTranslationDocumentDto;
    const files = event.target.files;
    for(var i = 0; i < files.length; i++){
      const file = event.target.files[i];
      if(file.type === "application/pdf"){
        const formData = new FormData();
        formData.append("files", file);
        // 
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        };
        await axios
          .post(URL + "/uploads/add", formData, config)
          .then((response) => {
            array.push({
                image: response.data,
                imageName: file.name
            })
            this.state.name2 += file.name + " ";
          })
          .catch((error) => {
            this.setState({
              alertErrorMessage: error.response.data,
            });
          });
      }
    }
    await this.setState({otherTranslationDocumentDto: array});
  };

  deleteImage3 = (event) => {
    var index = -1;
    let array = this.state.otherTranslationDocumentDto;
     this.state.otherTranslationDocumentDto.forEach((element) => {
      index++;
        if(element.image === event){         
          if (index !== -1) {
            array.splice(index, 1);
            this.setState({otherTranslationDocumentDto: array});
          }
        }
     });
  };

  ticketClick = () => {
    window.open("/diger-islemler-bilgilendirme-sistemi/" + this.state.customerGuid + "/" + this.state.guid + "/1", "_blank");
    this.setState({
      isLoading: false,
    });
  };

  enTicketClick = () => {
    window.open("/other-processes-information-system/" + this.state.customerGuid + "/" + this.state.guid + "/1", "_blank");
    this.setState({
      isLoading: false,
    });
  };

  fileClick = (image) => {
    var myData = image;
    let replaceLink = myData.replace(localFilePath + "/Files/", "");
    if (replaceLink) {
      window.open("/Files/" + myData, "_blank");
      this.setState({
        isLoading: false,
      });
    }
  };

  handleSendPayment = async () => {
    this.setState({
      isOpenModalPayment: !this.state.isOpenModalPayment,
    });
  };

  handleSendPaymentEFT = async () => {
    this.setState({
      isOpenModalPaymentEFT: !this.state.isOpenModalPaymentEFT,
    });
  };

  handleSendMailPayment = async () => {
    this.setState({
      isLoadingModal: true,
    });
    if(this.state.paymentValue === "" || this.state.paymentValue === null){
      this.setState({
        paymentValueError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
        isLoadingModal: false,
      });
    }
    else if(this.state.paymentValue !== "" || this.state.paymentValue !== null){
      this.setState({
        isLoadingModal: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var URLParam = "/customerDocumentOthers/otherpaymentsendmail";
      var myObj = {
        guid: this.state.guid,
        customerName: this.state.customerName,
        customerMail: this.state.customerMail,
        total: parseFloat(this.state.paymentValue),
      };
       axios
        .post(URL + URLParam, myObj, config)
        .then(() => {
          setTimeout(() => {
              window.location.reload();
            this.setState({
              isLoadingModal: false,
            });
          }, 1500);
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoadingModal: false,
          });
        });
    }
    else {
      this.setState({
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handleSendMailPaymentEFT = async () => {
    this.setState({
      isLoadingModal: true,
    });
    if(this.state.paymentValueEFT === "" || this.state.paymentValueEFT === null){
      this.setState({
        paymentValueError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
        isLoadingModal: false,
      });
    }
    else if(this.state.paymentValueEFT !== "" || this.state.paymentValueEFT !== null){
      this.setState({
        isLoadingModal: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var URLParam = "/customerDocumentOthers/addpayment";
      var myObj = {
        guid: this.state.guid,
        customerName: this.state.customerName,
        customerMail: this.state.customerMail,
        addTotal: parseFloat(this.state.paymentValueEFT),
      };
       axios
        .post(URL + URLParam, myObj, config)
        .then(() => {
          setTimeout(() => {
              window.location.reload();
            this.setState({
              isLoadingModal: false,
            });
          }, 1500);
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoadingModal: false,
          });
        });
    }
    else {
      this.setState({
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }


  handleChange = async (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handleSave = async (event) => {
    event.preventDefault();
    this.setState({
      isLoading: true,
    });
    if(this.state.customerDocumentOtherImageDto === null || this.state.customerDocumentOtherImageDto.length === 0){
      this.setState({
        customerDocumentOtherImageDtoError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
        isLoading: false,
      });
    }
    else if(this.state.customerDocumentOtherImageDto !== null || this.state.customerDocumentOtherImageDto.length !== 0){
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var URLParam = "/customerDocumentOthers/updateimage";
      var myObj = {
        guid: this.state.guid,
        customerDocumentOtherImageDto: this.state.customerDocumentOtherImageDto,
        otherTranslationDocumentDto: this.state.otherTranslationDocumentDto,
      };
       await axios
        .post(URL + URLParam, myObj, config)
        .then((response) => {
          setTimeout(() => {
            window.location.href = "/musteri-diger-islemler-listele";
          }, 1500);
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
    else {
      this.setState({
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  render() {
    const mainRow = {
      backgroundColor: "#1d4b8c",
      color: "#fff",
    };
    var self1 = this;
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body className="table-responsive">
              <CgnLoader visibled={this.state.isLoading} />
              
              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Müşteri</th>
                    <td colSpan="4">
                      {this.state.customerName ? this.state.customerName : "-"}
                    </td>
                  </tr>
                  <tr>
                    <th>Teklif</th>
                    <td colSpan="4">
                      {this.state.customerName + "-" + this.state.offerTotal + " " + (this.state.currencyType === 1 ? "TL" : 
                      this.state.currencyType === 2 ? "$" : this.state.currencyType === 3 ? "€" : "")}
                    </td>
                  </tr>
                  <tr>
                    <th>Açıklama</th>
                    <td colSpan="4">
                      {this.state.description
                        ? this.state.description
                        : "-"}
                    </td>
                  </tr>              
                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                    <th>Kaydedilme Tarihi</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                    <th>Son Güncellenme Tarihi</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>
                </tbody>
              </Table>    

              {this.state.customerDocumentOtherImageDto &&
                this.state.customerDocumentOtherImageDto.length > 0 && (
                  <Table className="table table-responsive table-hover table-product2 mb-3">
                    <tr style={mainRow}>
                      <th>Müşteri Belgeleri</th>
                    </tr>
                    <Row>
                      {this.state.customerDocumentOtherImageDto.map(function (item) {
                        return (
                          <>
                            <div className="pl-2">
                              <Button
                                onClick={() => self1.fileClick(item.image)}
                                className="modalButtonDetail"
                              >
                                <img
                                  src={pdfIcon}
                                  style={fotoStyle2}
                                  alt={item.imageName}
                                />
                              </Button>
                              <p style={{ maxWidth: "150px" }}>
                                {item.imageName}
                              </p>
                            </div>
                          </>
                        );
                      })}
                    </Row>
                  </Table>
                )}

             {this.state.otherTranslationDocumentDto &&
                this.state.otherTranslationDocumentDto.length > 0 && (
                  <Table className="table table-responsive table-hover table-product2 mb-3">
                    <tr style={mainRow}>
                      <th>Çeviri Belgeleri</th>
                    </tr>
                    <Row>
                      {this.state.otherTranslationDocumentDto.map(function (item) {
                        return (
                          <>
                            <div className="pl-2">
                              <Button
                                onClick={() => self1.fileClick(item.image)}
                                className="modalButtonDetail"
                              >
                                <img
                                  src={pdfIcon}
                                  style={fotoStyle2}
                                  alt={item.imageName}
                                />
                              </Button>
                              <p style={{ maxWidth: "150px" }}>
                                {item.imageName}
                              </p>
                            </div>
                          </>
                        );
                      })}
                    </Row>
                  </Table>
                )}

                <Row className="mt-3" style={{display: this.state.total !== 0 ? "" : "none", color:"red"}}>
                   <div>
                    <p style={{fontWeight: "bold"}}>Gönderilen Ödeme Tutarı : {this.state.total + " " + (this.state.currencyType === 1 ? "TL" :
                  this.state.currencyType === 2 ? "$" : this.state.currencyType === 3 ? "€" : "")}</p>
                 <p style={{fontWeight: "bold"}}>Kalan Ödeme Tutarı : {(parseFloat(this.state.offerTotal) - parseFloat(this.state.total)).toFixed(2) + " " + (this.state.currencyType === 1 ? "TL" :
                  this.state.currencyType === 2 ? "$" : this.state.currencyType === 3 ? "€" : "")}</p>
                   </div>
                </Row>
            </Card>
            <Card body className="table-responsive">   
            <Form onSubmit={this.handleSave}>              
                  <Col lg="12" className="pl-0">
                  <ImageUploadMulti
                      images={this.state.customerDocumentOtherImageDto}
                      noFoto={noImg}
                      style={fotoStyle}
                      pdfIcon={pdfIcon}
                      accept="application/pdf"
                      className="text-center text-danger"
                      label={"Müşteri Belgeleri"}
                      onChange={this.uploadedImage2}
                      onDelete={this.deleteImage2}
                      error={this.state.customerDocumentOtherImageDtoError}
                    />
                    </Col>
                    <Col lg="12" className="pl-0">
                  <ImageUploadMulti
                      images={this.state.otherTranslationDocumentDto}
                      noFoto={noImg}
                      style={fotoStyle}
                      pdfIcon={pdfIcon}
                      accept="application/pdf"
                      className="text-center text-danger"
                      label={"Çeviri Belgeleri"}
                      onChange={this.uploadedImage3}
                      onDelete={this.deleteImage3}
                      error={this.state.otherTranslationDocumentDtoError}
                    />
                    </Col>                       
                    <CgnButtonGroup items={this.state.buttons} />
                 </Form>
                {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />

            <CgnButton
              style={{float:"right"}}
              type="button"
              color="primary"
              className="sendEmailButton mr-3"
              onClick={() => this.ticketClick()}
              text={"Ticket Sistemi"}
              target="_blank"
            />

            <CgnButton
              style={{float:"right", width: "150px"}}
              type="button"
              color="primary"
              className="sendEmailButton mr-3"
              onClick={() => this.enTicketClick()}
              text={"EN Ticket Sistemi"}
              target="_blank"
            />

              <CgnButton
              style={{display: (parseFloat(this.state.offerTotal) - parseFloat(this.state.total)) > 0 ? "" : "none", float:"right"}}
              type="button"
              color="primary"
              className="sendEmailButton mr-3"
              onClick={() => this.handleSendPayment()}
              text={"Ödeme Ekle"}
            />

            <CgnButton
              style={{display: (parseFloat(this.state.offerTotal) - parseFloat(this.state.total)) > 0 ? "" : "none", float:"right"}}
              type="button"
              color="primary"
              className="sendEmailButton mr-3"
              onClick={() => this.handleSendPaymentEFT()}
              text={"Gelen Ödeme"}
            />

            <Modal
              isOpen={this.state.isOpenModalPayment}
              toggle={this.handleSendPayment}
              className="modal-xl content"
            >
              <ModalHeader className="font-weight-bold">
                Ödeme Gönder
              </ModalHeader>
              <ModalBody className="modalBody">
              <CgnLoader visibled={this.state.isLoadingModal} />
                <Row>
                  <Col>
                  <p style={{color: "red", fontWeight: "bold"}}>Toplam Teklif Tutarı : {this.state.offerTotal + " " + (this.state.currencyType === 1 ? "TL" :
                  this.state.currencyType === 2 ? "$" : this.state.currencyType === 3 ? "€" : "")}</p>
                  <p style={{color: "red", fontWeight: "bold"}}>Toplam Ödenen Tutar : {this.state.remainingAmount + " " + (this.state.currencyType === 1 ? "TL" :
                  this.state.currencyType === 2 ? "$" : this.state.currencyType === 3 ? "€" : "")}</p>
                    <CgnTextbox
                      type="number"
                      name="paymentValue"
                      label="Ödenecek Tutar"
                      value={this.state.paymentValue}
                      placeHolder="Lütfen ödenecek tutarı girin..."
                      autoComplete="off"
                      onChange={(e) => this.handleChange(e)}
                      step="0.1"
                    />
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
              <CgnButton
                  type="button"
                  color="primary"
                  onClick={this.handleSendMailPayment}
                  text="Gönder"
                  className="modalButton"
                />
                <CgnButton
                  type="button"
                  color="secondary"
                  onClick={this.handleSendPayment}
                  text="Kapat"
                  className="modalButton"
                />
              </ModalFooter>
            </Modal>

            <Modal
              isOpen={this.state.isOpenModalPaymentEFT}
              toggle={this.handleSendPaymentEFT}
              className="modal-xl content"
            >
              <ModalHeader className="font-weight-bold">
                Gelen Ödeme Ekle
              </ModalHeader>
              <ModalBody className="modalBody">
              <CgnLoader visibled={this.state.isLoadingModal} />
                <Row>
                  <Col>
                  <p style={{color: "red", fontWeight: "bold"}}>Toplam Teklif Tutarı : {this.state.offerTotal + " " + (this.state.currencyType === 1 ? "TL" :
                  this.state.currencyType === 2 ? "$" : this.state.currencyType === 3 ? "€" : "")}</p>
                  <p style={{color: "red", fontWeight: "bold"}}>Toplam Ödenen Tutar : {this.state.remainingAmount + " " + (this.state.currencyType === 1 ? "TL" :
                  this.state.currencyType === 2 ? "$" : this.state.currencyType === 3 ? "€" : "")}</p>
                    <CgnTextbox
                      type="number"
                      name="paymentValueEFT"
                      label="Gelen Ödeme Tutarı"
                      value={this.state.paymentValueEFT}
                      placeHolder="Lütfen gelen ödeme tutarı girin..."
                      autoComplete="off"
                      onChange={(e) => this.handleChange(e)}
                      step="0.1"
                    />
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
              <CgnButton
                  type="button"
                  color="primary"
                  onClick={this.handleSendMailPaymentEFT}
                  text="Ekle"
                  className="modalButton"
                />
                <CgnButton
                  type="button"
                  color="secondary"
                  onClick={this.handleSendPayment}
                  text="Kapat"
                  className="modalButton"
                />
              </ModalFooter>
            </Modal>
          </Col>
        </Row>
      </>
    );
  }
}

export default CustomerDocumentOtherDetail;
